var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row export" },
    [
      _c("label", { staticClass: "text" }, [
        _vm._v(_vm._s(_vm.$t("action.generatePDF"))),
      ]),
      _vm._v(" "),
      _c("HKLSelect", {
        attrs: {
          value: _vm.selectedValue || undefined,
          options: _vm.exportHklOptions,
          dropdownClassName: "export-pdf-dropdown",
          showSearch: false,
          placeholder: "",
        },
        on: { change: _vm.exportPDF },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }